export const trimHTML = (html?: string): string => {
  return html?.length ? html.replace(/(<([^>]+)>)/gi, '') : '';
};
